var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"category"},_vm._l((_vm.categories),function(cat){return _c('CategoryCard',{attrs:{"item":cat}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }